module.exports = __webpack_public_path__ + "static/media/cracking-the-code-tablet.408ac455.jpg";